var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudsDeviceBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320.59 154.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00b4e4;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 81.41,
    cy: 41.5,
    r: 41.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 132.91,
    cy: 41.5,
    r: 25.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34.54,
    cy: 51.63,
    r: 15.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 201.04,
    cy: 51.63,
    r: 15.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 163.04,
    cy: 131.13,
    r: 23.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 301.04,
    cy: 51.63,
    r: 15.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 252.54,
    cy: 51.63,
    r: 15.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 167.54,
    cy: 51.63,
    r: 30.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.12,
    cy: 44.2,
    r: 24.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.41,143.46c0,2.72-2.2,4.92-4.92,4.92h-12.77c-2.72,0-4.92-2.2-4.92-4.92v-20.87c0-2.72,2.2-4.92,4.92-4.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m123.75,32.12c-2.89-4.99-8.29-8.35-14.48-8.35-4.68,0-8.91,1.93-11.95,5.03-2.85-8.2-10.63-14.1-19.8-14.1-9.91,0-18.19,6.88-20.38,16.11-2.49-3.24-6.39-5.34-10.79-5.34-7.51,0-13.6,6.09-13.6,13.6,0,.01,0,.02,0,.04-1.83-2.75-4.95-4.57-8.51-4.57-5.64,0-10.2,4.57-10.2,10.2,0,.47.04.93.11,1.39-1.34-.87-2.93-1.39-4.64-1.39-4.7,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5h114.07m89.84,0h1.3c6.26,0,11.34-5.08,11.34-11.34s-5.08-11.34-11.34-11.34c-2.58,0-4.96.87-6.86,2.33.03-.4.06-.79.06-1.19,0-10.02-8.12-18.14-18.14-18.14-5.91,0-11.14,2.84-14.45,7.21-1.74-12.4-12.36-21.94-25.23-21.94-13.59,0-24.69,10.62-25.47,24.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m319.59,41.57c0-6.99-5.67-12.65-12.65-12.65-4.59,0-8.61,2.46-10.82,6.12-1.76-3.62-5.46-6.12-9.75-6.12-.6,0-1.18.06-1.75.15-.46-8.24-7.28-14.79-15.64-14.79s-15.67,7.01-15.67,15.67c0,.67.05,1.32.13,1.97-1.35-.38-2.78-.59-4.26-.59-8.65,0-15.67,7.01-15.67,15.67s7.01,15.67,15.67,15.67c.06,0,.11,0,.17,0h0s49.53,0,49.53,0c5.25,0,9.63-3.74,10.63-8.7,5.76-1.19,10.09-6.28,10.09-12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m137.94,75.31c-7.78,0-14.09-6.31-14.09-14.09s6.31-14.09,14.09-14.09l-.16-.66c1.39-11.65,11.3-20.67,23.32-20.67,8.43,0,15.82,4.44,19.96,11.11l.58,1.61c6.72,0,12.6,3.61,15.81,8.99l.08-.27c.56-.07,1.14-.1,1.72-.1,7.78,0,14.09,6.31,14.09,14.09s-6.31,14.09-14.09,14.09h-61.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m154.75,50.1l2.27-9.31c.64-2.64,3.31-4.26,5.94-3.61l12.4,3.03c2.64.64,4.26,3.31,3.61,5.94l-1.19,4.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m183.54,38.01l3.1-5.12c1.42-2.31,4.45-3.04,6.77-1.61l10.87,6.69c2.31,1.42,3.04,4.45,1.61,6.77l-1.68,2.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.77,58.44c1.86-6.92,8.18-12.02,15.69-12.02,6.64,0,12.35,3.99,14.87,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m124.27,56.85l-7.64-15.08c-1.23-2.42-.26-5.38,2.17-6.61l11.39-5.77c2.42-1.23,5.38-.26,6.61,2.17l3.22,6.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 123.24,
    y1: 46.04,
    x2: 136.32,
    y2: 39.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 125.19,
    y1: 49.91,
    x2: 138.28,
    y2: 43.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 131.1,
    y1: 33.98,
    x2: 132.74,
    y2: 33.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 200.97,
    y1: 41.39,
    x2: 202.51,
    y2: 42.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 188.19,
    y1: 37.61,
    x2: 200.44,
    y2: 45.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m43.56,24.8l-3.1-5.12c-1.42-2.31-4.45-3.04-6.77-1.61l-10.87,6.69c-2.31,1.42-3.04,4.45-1.61,6.77l1.68,2.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.13,
    y1: 28.18,
    x2: 24.6,
    y2: 29.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.91,
    y1: 24.4,
    x2: 26.66,
    y2: 32.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 173.31,
    y1: 44.43,
    x2: 175.08,
    y2: 44.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 160,
    y1: 44.3,
    x2: 174.44,
    y2: 47.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m68.62,47.03l-2.97-13.36c-.59-2.65,1.08-5.28,3.73-5.87l12.46-2.77c2.65-.59,5.28,1.08,5.87,3.73l2.67,12.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.99,
    y1: 37.69,
    x2: 85.31,
    y2: 34.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.62,
    y1: 41.44,
    x2: 85.94,
    y2: 38.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 81.6,
    y1: 29.7,
    x2: 83.39,
    y2: 29.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94.72,43.37c-3.07-2.26-6.85-3.61-10.96-3.61-7.67,0-14.25,4.66-17.06,11.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "145.65 112.51 145.65 95.01 140.69 95.01 164.3 75.41 187.9 95.01 182.85 95.01 182.85 112.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 158.94,
    y1: 125.86,
    x2: 173.61,
    y2: 125.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 158.94,
    y1: 130.53,
    x2: 173.61,
    y2: 130.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 158.94,
    y1: 135.19,
    x2: 166.28,
    y2: 135.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.5,123v15.27c0,2.72-2.2,4.92-4.92,4.92h-12.77c-2.72,0-4.92-2.2-4.92-4.92v-20.87c0-2.72,2.2-4.92,4.92-4.92h7.58c1.55.02,3.03.63,4.14,1.72l4.36,4.26c.77.76,1.31,1.7,1.59,2.73l.02,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m168.64,112.66s.02.61.02,3.78,2.22,4.91,4.94,4.9l3.31-.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsDeviceBlue);
export default __webpack_public_path__ + "static/media/clouds_device_blue.b32336863643ea9baa0f5a26efba7cfa.svg";
export { ForwardRef as ReactComponent };